import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class IconFlame extends Component {
	static displayName = 'IconFlame';

	getLarge() {
		return (
			<svg
				fill={this.props.color}
				xmlns="http://www.w3.org/2000/svg"
				width="25"
				height="32"
				viewBox="0 0 25 32">
				<path d="M25.143 30.286v1.143q0 0.232-0.17 0.402t-0.402 0.17h-24q-0.232 0-0.402-0.17t-0.17-0.402v-1.143q0-0.232 0.17-0.402t0.402-0.17h24q0.232 0 0.402 0.17t0.17 0.402zM20.571 11.429q0 1.393-0.438 2.571t-1.143 2.009-1.563 1.571-1.714 1.384-1.563 1.286-1.143 1.455-0.438 1.723q0 1.714 1.196 4l-0.071-0.018 0.018 0.018q-1.607-0.732-2.857-1.482t-2.473-1.786-2.027-2.188-1.295-2.688-0.491-3.286q0-1.393 0.438-2.571t1.143-2.009 1.563-1.571 1.714-1.384 1.563-1.286 1.143-1.455 0.438-1.723q0-1.679-1.179-4l0.054 0.018-0.018-0.018q1.607 0.732 2.857 1.482t2.473 1.786 2.027 2.188 1.295 2.688 0.491 3.286z" />
			</svg>
		);
	}

	getSmall() {
		return (
			<svg
				fill={this.props.color}
				xmlns="http://www.w3.org/2000/svg"
				width="19"
				height="24"
				viewBox="0 0 19 24">
				<path d="M18.4538824,22.0842353 L18.4538824,22.8910588 C18.4538824,23.0002353 18.4138824,23.0948235 18.3338824,23.1748235 C18.2538824,23.2548235 18.1592941,23.2948235 18.0501176,23.2948235 L1.10894118,23.2948235 C0.999764706,23.2948235 0.905176471,23.2548235 0.825176471,23.1748235 C0.745176471,23.0948235 0.705176471,23.0002353 0.705176471,22.8910588 L0.705176471,22.0842353 C0.705176471,21.9750588 0.745176471,21.8804706 0.825176471,21.8004706 C0.905176471,21.7204706 0.999764706,21.6804706 1.10894118,21.6804706 L18.0501176,21.6804706 C18.1592941,21.6804706 18.2538824,21.7204706 18.3338824,21.8004706 C18.4138824,21.8804706 18.4538824,21.9750588 18.4538824,22.0842353 Z M15.2265882,8.77341176 C15.2265882,9.42894118 15.1235294,10.0338824 14.9174118,10.5882353 C14.7112941,11.1425882 14.4423529,11.6152941 14.1105882,12.0063529 C13.7788235,12.3974118 13.4110588,12.7670588 13.0072941,13.1152941 C12.6035294,13.4635294 12.2002353,13.7891765 11.7974118,14.0922353 C11.3945882,14.3952941 11.0268235,14.6978824 10.6941176,15 C10.3614118,15.3021176 10.0924706,15.6444706 9.88729412,16.0270588 C9.68211765,16.4096471 9.57905882,16.8150588 9.57811765,17.2432941 C9.57811765,18.0498824 9.85952941,18.9910588 10.4223529,20.0668235 L10.3722353,20.0541176 L10.3849412,20.0668235 C9.62870588,19.7223529 8.95647059,19.3736471 8.36823529,19.0207059 C7.78,18.6677647 7.19811765,18.2475294 6.62258824,17.76 C6.04705882,17.2724706 5.57011765,16.7576471 5.19176471,16.2155294 C4.81341176,15.6734118 4.50870588,15.0409412 4.27764706,14.3181176 C4.04658824,13.5952941 3.93105882,12.8221176 3.93105882,11.9985882 C3.93105882,11.3430588 4.03411765,10.7381176 4.24023529,10.1837647 C4.44635294,9.62941176 4.71529412,9.15670588 5.04705882,8.76564706 C5.37882353,8.37458824 5.74658824,8.00494118 6.15035294,7.65670588 C6.55411765,7.30847059 6.95741176,6.98282353 7.36023529,6.67976471 C7.76305882,6.37670588 8.13082353,6.07411765 8.46352941,5.772 C8.79623529,5.46988235 9.06517647,5.12752941 9.27035294,4.74494118 C9.47552941,4.36235294 9.57858824,3.95694118 9.57952941,3.52870588 C9.57952941,2.73858824 9.30211765,1.79741176 8.74729412,0.705176471 L8.78541176,0.717882353 L8.77270588,0.705176471 C9.52894118,1.04964706 10.2011765,1.39835294 10.7894118,1.75129412 C11.3776471,2.10423529 11.9595294,2.52447059 12.5350588,3.012 C13.1105882,3.49952941 13.5875294,4.01435294 13.9658824,4.55647059 C14.3442353,5.09858824 14.6489412,5.73105882 14.88,6.45388235 C15.1110588,7.17670588 15.2265882,7.94988235 15.2265882,8.77341176 Z" />
			</svg>
		);
	}

	getIcon() {
		let svg;
		svg = this.props.size === 'large' ? this.getLarge() : svg;
		svg = this.props.size === 'small' ? this.getSmall() : svg;
		return svg;
	}

	render() {
		return this.getIcon();
	}
}

IconFlame.propTypes = {
	size: PropTypes.oneOf(['small', 'large']).isRequired,
};
